import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

const PageResources = Resources.PortfolioDetail.Services;

type Props = {
	baseData: PortfolioDetailResponseDTO;
	depositAmount: string;
};

export const ServicesBasicInfoDetails: FC<Props> = ({
	baseData,
	depositAmount,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const hasDetails =
		baseData.signedAt || baseData.startAt || baseData.endAt || depositAmount;

	if (!hasDetails) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.DataCard.BasicInfo.additionalInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(PageResources.AdditionalInfo.signDate)}
					value={dateFormatter(baseData.signedAt)}
				/>
				<DetailRow
					label={t(PageResources.AdditionalInfo.beginDate)}
					value={dateFormatter(baseData.startAt)}
				/>
				<DetailRow
					label={t(PageResources.AdditionalInfo.endDate)}
					value={dateFormatter(baseData.endAt)}
				/>
				<DetailRow
					label={t(PageResources.AdditionalInfo.depositAmount)}
					value={depositAmount}
				/>
			</Stack>
		</>
	);
};
